// src/components/Login.js
import React from "react";
import userManager from "../auth/UserManager";

const Login = () => {
  const handleLogin = () => {
    userManager.signinRedirect();
  };

  return (
    <div>
      <h2>Login</h2>
      <button onClick={handleLogin}>Login with OpenID Connect</button>
    </div>
  );
};

export default Login;
